import StorageIcon from '@mui/icons-material/Storage';
import ValkeyList from './ValkeyList';
import ValkeyShow from './ValkeyShow';
import ValkeyCreate from './ValkeyCreate';
import ValkeyEdit from './ValkeyEdit';

export default {
    list: ValkeyList,
    show: ValkeyShow,
    create: ValkeyCreate,
    edit: ValkeyEdit,
    icon: StorageIcon,
};
